import {MessageKey, t} from '@/i18n'

export type Operator = {
    /**
     * IDENTIFICADOR PERSISTIDO. É por este valor que checkExpression resolve o
     * operador (objectOf(operators, 'text')) e é ele que fica gravado em
     * exp.operator dentro de cada condição salva no banco. NÃO TRADUZIR e NÃO
     * RENOMEAR: mudar aqui quebra toda condição já existente.
     */
    text: string
    /** Rótulo visível. Use sempre isto para desenhar, nunca o `text`. */
    labelKey: MessageKey
    simpleVersion?: string
    single: boolean
    targetProperty?: boolean
    types?: string[]
    // eslint-disable-next-line no-unused-vars
    eval: (v1: any, v2?: any) => boolean
}

const operators: Operator[] = [
    { text: 'is not empty', labelKey: 'operator.is-not-empty', single: true, eval: v => v && !!('' + v).trim() },
    { text: 'is empty', labelKey: 'operator.is-empty', single: true, eval: v => !v || !('' + v).trim() },
    { text: '>', labelKey: 'operator.gt', single: false, types: ['number', 'date', 'boolean'], eval: (v1, v2) => v1 > v2 },
    { text: '≥', labelKey: 'operator.gte', single: false, types: ['number', 'date', 'boolean'], eval: (v1, v2) => v1 >= v2 },
    { text: '<', labelKey: 'operator.lt', single: false, types: ['number', 'date', 'boolean'], eval: (v1, v2) => v1 < v2 },
    { text: '≤', labelKey: 'operator.lte', single: false, types: ['number', 'date', 'boolean'], eval: (v1, v2) => v1 <= v2 },
    { text: '≠', labelKey: 'operator.ne', single: false, types: ['number', 'date', 'boolean'], eval: (v1, v2) => v1 != v2 },
    {
        text: '> other property',
        labelKey: 'operator.gt-property',
        simpleVersion: '>',
        single: false,
        targetProperty: true,
        types: ['number', 'date', 'boolean'],
        eval: (v1, v2) => v1 > v2
    },
    {
        text: '≥ other property',
        labelKey: 'operator.gte-property',
        simpleVersion: '≥',
        single: false,
        targetProperty: true,
        types: ['number', 'date', 'boolean'],
        eval: (v1, v2) => v1 >= v2
    },
    {
        text: '< other property',
        labelKey: 'operator.lt-property',
        simpleVersion: '<',
        single: false,
        targetProperty: true,
        types: ['number', 'date', 'boolean'],
        eval: (v1, v2) => v1 < v2
    },
    {
        text: '≤ other property',
        labelKey: 'operator.lte-property',
        simpleVersion: '≤',
        single: false,
        targetProperty: true,
        types: ['number', 'date', 'boolean'],
        eval: (v1, v2) => v1 <= v2
    },
    {
        text: '≠ other property',
        labelKey: 'operator.ne-property',
        simpleVersion: '≠',
        single: false,
        targetProperty: true,
        types: ['number', 'date', 'boolean'],
        eval: (v1, v2) => v1 != v2
    },
    { text: 'matches regex', labelKey: 'operator.matches-regex', single: false, types: ['text'], eval: (v, regex) => new RegExp(regex).test(v) }
]

/** Rótulo traduzido a partir do identificador persistido. */
export function operatorLabel(text: string): string {
    const operator = operators.find(o => o.text === text)
    return operator ? t(operator.labelKey) : text
}

export default operators
